module.exports = __webpack_public_path__ + "static/media/billiard.7d1de758.png";